import { render, staticRenderFns } from "./SwitchCom.vue?vue&type=template&id=d6012e16&scoped=true&"
import script from "./SwitchCom.vue?vue&type=script&lang=js&"
export * from "./SwitchCom.vue?vue&type=script&lang=js&"
import style0 from "./SwitchCom.vue?vue&type=style&index=0&id=d6012e16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6012e16",
  null
  
)

export default component.exports